import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { List } from '../../models/list.model';
import {
  ConfirmEmail,
  ResetPasswordRequest,
  SetPassword,
  User,
  UserRegister,
  UserUpdate,
} from 'src/app/models/user.model';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient, public authService: AuthService) {}

  configService = inject(ConfigService);

  load(params: {
    page: number;
    pageSize: number;
    sort: string;
    sortDirection: string;
    filters: string[];
  }): Observable<List<User>> {
    let url =
      this.configService.readConfig().baseUrlGateway +
      '/admin/v1/users' +
      `?PageSize=${params.pageSize}&PageNumber=${params.page}&Sort=${params.sort}&SortDirection=${params.sortDirection}`;

    if (params.filters && params.filters.length > 0) {
      url += `&Filter=${params.filters.join('&Filter=')}`;
    }

    return this.http.get<List<User>>(url);
  }

  public register(user: UserRegister): Observable<any> {
    const url =
      this.configService.readConfig().baseUrlGateway +
      '/admin/v1/useraccountadmin/register';
    return this.http.post(url, user, { observe: 'response' });
  }

  public setPassword(data: SetPassword): Observable<any> {
    const url = this.configService.readConfig().baseUrlGateway + '/setpass';
    return this.http.post(url, data, { observe: 'response' });
  }

  public resetPassword(data: ResetPasswordRequest): Observable<any> {
    const url = this.configService.readConfig().baseUrlGateway + '/resetpass';
    return this.http.post(url , data,  { observe: 'response' });
  }

  public confirmEmail(data: ConfirmEmail): Observable<any> {
    const url =
      this.configService.readConfig().baseUrlGateway + '/useraccount/confirm-email';
    return this.http.post(url, data, { observe: 'response' });
  }

  public update(user: UserUpdate): Observable<any> {
    const url =
      this.configService.readConfig().baseUrlGateway +
      '/admin/v1/useraccountadmin/update';
    return this.http.post(url, user, { observe: 'response' });
  }
}
